import styled from 'styled-components';
import {
  Card,
  Dimmer,
  Input as SemanticInput,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Header as HeaderLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled(Dimmer)``;

export const Dialog = styled(Card)`
  &.ui.card {
    display: flex;
    padding: 30px;
    width: 430px;
    background-color: ${({ theme }) => theme.background};
    border-radius: 1px;

    :after {
      display: none;
    }
  }
`;

export const Text = styled(TextLayoutComponent)`
  text-align: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Header = styled(HeaderLayoutComponent)`
  text-align: left;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonArea = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 90px;
  }
`;

export const ButtonInverted = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    width: 90px;
  }
`;

export const Input = styled(SemanticInput)`
  &.ui.input {
    margin: 5px 0;
    width: 155px;
  }
`;
